import React from 'react';

type Props = {
    className?: string;
    classNameTitle?: string;
    title: string;
    description: string;
};

export const PageHeader: React.FC<Props> = ({ className, classNameTitle, title, description, children }) => {
    return (
        <div className={`page-header${className ? ` ${className}` : ''}`}>
            <div className="container">
                <h1 className={`page-title${classNameTitle ? ` ${classNameTitle}` : ''}`}>{title}</h1>
                <p className="page-description">{description}</p>
                {children}
            </div>
        </div>
    );
};
